<div class="search-modal">
  <div class="search-modal__header">
    <div class="search-modal__input-wrapper" [class.search-modal__input-wrapper--active]="hasSearchTerm">
      <span class="search-modal__icon" aria-hidden="true"></span>
      <input
        #searchInput
        class="search-modal__input"
        type="search"
        enterkeyhint="search"
        inputmode="search"
        autocorrect="off"
        autocomplete="off"
        spellcheck="false"
        [value]="searchString"
        (input)="onInput($event)"
        placeholder="Pesquisar"
      >
      <button *ngIf="hasSearchTerm" class="search-modal__clear" (click)="clearSearch()">Limpar</button>
    </div>
    <button class="search-modal__close" (click)="dismiss()" aria-label="Fechar">
      <img src="assets/icon/search-modal-close.svg" aria-hidden="true">
    </button>
  </div>

  <div class="search-modal__body mb-3">

    <div *ngIf="!hasSearchTerm" class="search-modal__initial">
      <span class="search-modal__initial-icon" aria-hidden="true"></span>
    </div>

    <div *ngIf="hasSearchTerm && searchResultsEmpty" class="search-modal__empty">
      <span class="search-modal__empty-icon" aria-hidden="true"></span>
      <p class="search-modal__empty-text">Nenhum produto encontrado</p>
      <button class="search-modal__back-btn" (click)="dismiss()">Retornar ao cardápio</button>
    </div>

    <div *ngIf="hasSearchTerm && !searchResultsEmpty" class="search-modal__results new-design">
      <card
        class="search-modal__result-card"
        *ngFor="let product of flattenedResults; trackBy: trackById"
        [item]="product"
        [extrasList]="restaurant?.menu?.extras"
        [newHomePedirDelivery]="true">
      </card>
    </div>

  </div>
</div>
